export default "__VITE_ASSET__3QSZ8nBE__"